<template>
    <dashboard-layout tit="개인 근무 현황">
        <template slot="contents">

            <!-- 근무자 -->
            <worker-item class="mb-20 mb-lg-40" :value="contract" @deleteContract="deleteContract" :places="places"/>
            
            <v-badge floating dot >
                <h4 class="tit--sm line-height-1">근무 현황 조회</h4>
            </v-badge>

            <!-- 검색필터 -->
            <worker-personal-filter class="mt-12 mt-lg-20" />

            <!-- 리스트 -->
            <worker-personal-list class="mt-12 mt-lg-20" :employment="contract.employment" />

        </template>
    </dashboard-layout>
</template>

<script>
import api from '@/api';

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import WorkerPersonalFilter from "@/components/dashboard/company/worker/worker-personal-filter.vue";
import WorkerPersonalList from "@/components/dashboard/company/worker/worker-personal-list.vue";
import WorkerItem from "@/components/dashboard/company/worker/worker-item.vue";

export default {
    components: {
        DashboardLayout,
        WorkerPersonalFilter,
        WorkerPersonalList,
        WorkerItem,
    },
    data: () => ({
        contract: null,
        places: [],
    }),
    computed: {
    },
    mounted() {
        this.searchContract();
        this.placeList(); 
    },
    watch: {
    },
    methods: {
        async searchContract() {
            try{
                const { contract } = await api.v1.company.employment.contracts.get({ _id: this.$route.params.contract });
                this.contract = contract;
            } catch(e){
                console.error(e)
            }
        },
        async deleteContract(_contract) {
            if(confirm('삭제하시겠습니까?')){
                await api.v1.company.employment.contracts.delete({_id: _contract});
                alert('삭제되었습니다.');
                this.$router.push('/dashboard/worker');
            }
        },
        async placeList() {
            try{
                let { places } = await api.v1.company.employment.places.gets({});
                this.places = places;
                
            } catch(e) {
                console.error(e);
            }
        }
        

    },
};
</script>

<style></style>
